import { create } from "zustand";

const TICK_INTERVAL_MS = 30_000;

interface AccessExpiryState {
  expiresAt: Date | null;
  now: number;
}

interface AccessExpiryActions {
  setExpiresAt: (expiresAtIso: string | null | undefined) => void;
}

let tickHandle: ReturnType<typeof setInterval> | null = null;

function startTicker(set: (partial: Partial<AccessExpiryState>) => void) {
  if (tickHandle !== null) return;
  tickHandle = setInterval(() => {
    set({ now: Date.now() });
  }, TICK_INTERVAL_MS);
}

function stopTicker() {
  if (tickHandle === null) return;
  clearInterval(tickHandle);
  tickHandle = null;
}

export const useAccessExpiryStore = create<
  AccessExpiryState & AccessExpiryActions
>((set) => ({
  expiresAt: null,
  now: Date.now(),
  setExpiresAt: (expiresAtIso) => {
    if (!expiresAtIso) {
      stopTicker();
      set({ expiresAt: null, now: Date.now() });
      return;
    }
    const parsed = new Date(expiresAtIso);
    if (Number.isNaN(parsed.getTime())) {
      stopTicker();
      set({ expiresAt: null, now: Date.now() });
      return;
    }
    startTicker(set);
    set({ expiresAt: parsed, now: Date.now() });
  },
}));

export function selectMsLeft(state: AccessExpiryState): number | null {
  if (state.expiresAt === null) return null;
  return state.expiresAt.getTime() - state.now;
}

export function selectIsExpired(state: AccessExpiryState): boolean {
  const ms = selectMsLeft(state);
  return ms !== null && ms <= 0;
}
